import React, { useContext } from "react";

import { Button as MondrianButton } from "mondrian-react";
import { store } from "store.js";
import sanitize from "core/Utils/SanitizeString";
import { atributteFactory} from "core/Utils/Analytics/tagService";
import  {TagTypeGa4}  from "core/Utils/Analytics/tagType";
import tagAdapter from "core/Utils/Analytics/tagAdapter";

function handleTagAdapter(options, currentFlow,props)  {

  if(currentFlow ==="customer2fa"){
    if(props?.tagConfig){
      options={
        nome_item:options.nome_item,
        ...props?.tagConfig}
      tagAdapter(options,props?.tagConfig?.type)
    }
    else{
      tagAdapter(options,TagTypeGa4.BUTTON)
    }
  }
}

export default function Button({ type = "submit", ...props }) {
  const globalState = useContext(store);
  const { state } = globalState;
  const {currentFlow}  = state.analytics;
  const {currentStep= "validar-token"}  = state.analytics;

  
  let eventCategory = props['event-cagetory'] || 'minha-claro:meu-perfil';
  let eventAction = props['event-action'] || 'clique-botao';
  let label = sanitize(props["data-gtm-event-label"] || props.children);
  const atributteReturn  =atributteFactory(currentFlow,eventCategory,eventAction,label)
  const defaultConfig={"nome_item":label,"nome_secao":currentStep}

  return (
    <MondrianButton
      type={type}
      {...atributteReturn}
 
      {...props}
      onClick={(e) => {
        if( props.onClick){
        props.onClick(e);
      }
      handleTagAdapter(defaultConfig, currentFlow, props);
      }}
    
    >
      {props.children}
    </MondrianButton>
  );
}
